import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import {
    InputGroup,
    Label,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import { useSelector } from "react-redux";


const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .matches(/^[0-9]+$/, "Room count must be a number")
        .min(1, "No of Rooms must be at least 1")
        .max(2, "No of Room number must be at most 25")
        .test(
            "is-between-1-and-25",
            "No of Room must be between 1 and 25",
            (value) => {
                const number = parseInt(value, 10);
                return number >= 1 && number <= 25;
            }
        )
        .required("No. of rooms are required"),
});

const AddRoomNumber = ({
    setRoomNumberModel,
    selectedData,
    addRoomNumberLoading,
    addRoomNumberMutate,
    propId,
    isFlat,
}) => {
    const initialValues = {
        roomNumber: "",
    };
    const handleAddSubmit = (values) => {
        addRoomNumberMutate({
            propId: propId,
            rooms: [
                isFlat
                    ? {
                        flatId: selectedData.id,
                        roomCount: Number(values.roomNumber),
                    }
                    : {
                        floorNumber: String(selectedData.floor),
                        roomCount: Number(values.roomNumber),
                    },
            ],
        });
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setRoomNumberModel}
            title="Add Room"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleAddSubmit}
            >
                {() => (
                    <Form>
                        <InputGroup>
                            <Label>Enter No. of Rooms</Label>
                            <Field
                                type="number"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter number of rooms"
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-rose-500 text-xs mt-1"
                            />
                            <span className="items-center text-xs text-gray-400">No of Room must be less than or equal to 25</span>
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 mt-8">
                            <SideCancelBtn onClick={() => setRoomNumberModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={addRoomNumberLoading}>
                                {" "}
                                {addRoomNumberLoading ? "Submitting..." : "Submit"}
                            </SubmitBtn>
                        </div>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

export default AddRoomNumber;